<template>
  <div>
    <!-- 订单管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>撤销核销</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox" >
      <div class="conentTitle">
        <el-input placeholder="订单号" v-model="data.ordernumber" />
        <el-button  type="primary" @click="btns">查询</el-button>
        <!-- <el-button class="btnMar" type="primary" @click="exports">自定义表单</el-button> -->
        <!-- <el-button type="primary" @click="exportRoute">去导出</el-button> -->
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
          
        >
            <!-- 
            <el-table-column  prop="CreateTime" label="下单时间">
            </el-table-column>
            <el-table-column  prop="ordernumber" label="订单号">
            </el-table-column>
            <el-table-column prop="num" label="撤销数量"></el-table-column>
            <el-table-column prop="OrderCode" label="消费码"></el-table-column>
            <el-table-column prop="" label="订单金额">
              <template slot-scope="scope">
                  {{scope.row.DistributorID==0?scope.row.order_detail[0].OrderAll.agentprice:scope.row.ActFee}}
              </template>
            </el-table-column> -->
              <el-table-column  prop="created_at" label="撤销时间" width="240">
              </el-table-column>
              <el-table-column prop="" label="分销商">
                <template slot-scope="scope">
                  {{ scope.row.distributor_name?scope.row.distributor_name:'景区直销' }}
                </template>
              </el-table-column>
              <el-table-column prop="ordernumber" label="订单号"></el-table-column>
              <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
              <el-table-column prop="OrderCode" label="消费码"></el-table-column>
            <el-table-column prop="" label="订单金额">
              <template slot-scope="scope">
                  {{scope.row.ActFee}}
              </template>
            </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
   
  </div>
</template>

<script>
import { orderBackCancelList } from '@/request/scenic.js'
import {MessageBox,Message} from 'element-ui'
export default {
  
  data() {
    return {
     
      loading:true,
    
      tableData: [
      ],
      data:{
        token:window.sessionStorage.getItem('Token'),
        ordernumber:'',
        page:1,
        page_size:8,
      },
    };
  },
  created(){
    this.getList()
  },
  methods: {
    currenchange(e){
      this.data.page = e
      this.loading =  true
      this.getList()
    },
    // 查询
    btns(){
      this.data.total = 0
      this.data.page  = 1
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.data.page = 1
      this.getList()
    },
    getList(){
      orderBackCancelList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
          this.loading = false
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
   
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.tab_boxs{
  display: flex;
  align-items: center;
  margin-top: 1.8rem;
  >div{
    cursor: pointer;
    margin-right: 2rem;
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tab_active{
    background: #246DEB;
  }
}
/deep/.el-card__body {
  padding: 0 2rem;
}
.conentBox {
  margin-top: 17px;
  .conentTitle {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    .el-input,
    .el-select {
      width: 22rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .el-date-editor {
      width: 28rem;
      margin-bottom: 1rem;
      margin-right: 1rem;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
    .btnMar {
      width: 12rem;
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 2rem 2rem;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 2rem 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.mask {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask img{
  width: 34.5rem;
  height: 34.5rem;
}
.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;

  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
/deep/ .el-dialog__header{
  text-align: center;
}
/deep/.el-collapse-item__header{
  height:11rem;
}
.tkBtns{
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  ::v-deep .el-button{
    width: 20rem;
  }
}
::v-deep .el-checkbox-group{
  display: flex;
  flex-wrap: wrap;
  .el-checkbox{
      width:40%;
      margin-bottom: 2rem;
  }
}
::v-deep .is-checked .el-checkbox__label{
    color: #4ecb73;
  }
  .menu_btns{
    display: flex;
    justify-content: center;
    margin-top: 3rem;
    div{
      display: flex;
      justify-content: center;
      border-radius: 0.4rem;
      align-items: center;
      font-size: 1.4rem;
      cursor: pointer;
      &:nth-child(1){
        width: 9.8rem;
        height: 3.8rem;
        border: 0.1rem solid #246DEB;
        color: #246DEB;
      }
      &:nth-child(2){
        width: 10rem;
        height: 4rem;
        background: #246DEB;
        color: #fff;
        margin-left: 2rem;
      }
    }
  }
</style>